import { render, staticRenderFns } from "./adva.vue?vue&type=template&id=2a611e8e&scoped=true&"
import script from "./adva.vue?vue&type=script&lang=js&"
export * from "./adva.vue?vue&type=script&lang=js&"
import style0 from "./adva.vue?vue&type=style&index=0&id=2a611e8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a611e8e",
  null
  
)

export default component.exports